!(function () {
  "use strict";
  var e = document.getElementById("fa-form-1");
  if (e) {
    var t,
      n,
      r = {
        workerUrl: e.getAttribute("data-worker-url") || "",
        siteKey: e.getAttribute("data-site-key") || "",
        maxFiles: 10,
        maxTotalSize: 20971520,
        maxSingleSize: 10485760,
        fetchTimeout: 3e4,
        allowedTypes: [
          "image/jpeg",
          "image/png",
          "image/gif",
          "image/webp",
          "application/pdf",
        ],
      },
      i = {
        btn: document.getElementById("submit-btn"),
        tokenInput: document.getElementById("cf-turnstile-response"),
        name: document.getElementById("name"),
        email: document.getElementById("email"),
        enquiryType: document.getElementById("enquiryType"),
        countryType: document.getElementById("countryType"),
        enquiryMessage: document.getElementById("enquiryMessage"),
        orderNumber: document.getElementById("orderNumber"),
        attachment: document.getElementById("attachment"),
        startTime: document.getElementById("startTime"),
        popupMsg: document.getElementById("popup-message"),
        popup: document.getElementById("popup"),
        overlay: document.getElementById("overlay"),
        closePopup: document.getElementById("close-popup"),
        charCount: document.getElementById("msg-char-count"),
        fileList: document.getElementById("file-list"),
        fileSummary: document.getElementById("file-summary"),
        dropZone: document.getElementById("file-drop-zone"),
        iconSuccess: document.getElementById("popup-icon-success"),
        iconError: document.getElementById("popup-icon-error"),
        honeypot: document.getElementById("fa-website"),
      },
      a = {
        token: "",
        widgetId: null,
        submitting: !1,
        selectedFiles: [],
        formDirty: !1,
      },
      o = {
        name: function () {
          var e = i.name.value.trim();
          e
            ? e.length < 2
              ? m("name-hint", "Name seems too short.", "hint-warning")
              : m("name-hint", null)
            : m("name-hint", "Enter your first and last name.");
        },
        email: function () {
          var e = i.email.value.trim();
          e
            ? -1 === e.indexOf("@")
              ? m("email-hint", "Don’t forget the @ symbol.", "hint-warning")
              : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
                ? m("email-hint", "Looks good!", "hint-success")
                : m(
                    "email-hint",
                    "Double-check your email address.",
                    "hint-warning",
                  )
            : m("email-hint", "We’ll only use this to reply to you.");
        },
        orderNumber: function () {
          var e = i.orderNumber.value.trim();
          e
            ? d(e)
              ? m("orderNumber-hint", null)
              : m(
                  "orderNumber-hint",
                  "Try #123456 or US1234 format.",
                  "hint-warning",
                )
            : m(
                "orderNumber-hint",
                "Format: #123456 or US1234 — found in your confirmation email.",
              );
        },
        enquiryMessage: function () {
          var e = i.enquiryMessage.value.length;
          0 === e
            ? m(
                "msg-hint",
                "Describe your issue in detail so we can help faster.",
              )
            : e < 20
              ? m(
                  "msg-hint",
                  "A bit more detail helps us respond faster.",
                  "hint-warning",
                )
              : m("msg-hint", null);
        },
      },
      l =
        ((t = p),
        function () {
          var e = this,
            r = arguments;
          (clearTimeout(n),
            (n = setTimeout(function () {
              t.apply(e, r);
            }, 150)));
        }),
      s = "cf_contact_draft";
    ((window.onTurnstileLoaded = function () {
      null === a.widgetId &&
        "undefined" != typeof turnstile &&
        (a.widgetId = turnstile.render("#turnstile-container", {
          sitekey: r.siteKey,
          callback: function (e) {
            ((a.token = e),
              (i.tokenInput.value = e),
              i.tokenInput.setAttribute("data-touched", "true"),
              p());
          },
          "expired-callback": function () {
            ((a.token = ""), (i.tokenInput.value = ""), p());
          },
          "error-callback": function () {
            ((a.token = ""), (i.tokenInput.value = ""), p());
          },
        }));
    }),
      "loading" === document.readyState
        ? document.addEventListener("DOMContentLoaded", A)
        : A());
  }
  function u(e, t) {
    var n = document.getElementById(e + "-tooltip");
    if (n) {
      var r =
        document.getElementById(e) || ("recaptcha" === e ? i.tokenInput : null);
      r && "true" === r.getAttribute("data-touched") && t
        ? ((n.style.display = "block"),
          n.setAttribute("role", "alert"),
          r && r.setAttribute("aria-invalid", "true"))
        : ((n.style.display = "none"),
          n.removeAttribute("role"),
          r && r.setAttribute("aria-invalid", "false"));
    }
  }
  function d(e) {
    return !e || /^#?\d{6,10}$/.test(e) || /^(US|EU|CA)\d{4,10}$/i.test(e);
  }
  function c(e) {
    return e < 1024
      ? e + " B"
      : e < 1048576
        ? (e / 1024).toFixed(1) + " KB"
        : (e / 1048576).toFixed(1) + " MB";
  }
  function m(e, t, n) {
    var r = document.getElementById(e);
    r &&
      (t
        ? ((r.textContent = t),
          (r.className = "field-hint visible" + (n ? " " + n : "")))
        : (r.className = "field-hint"));
  }
  function y(e) {
    var t = o[e];
    t && t();
  }
  function f(e) {
    e &&
      ("" === e.value
        ? (e.className = (
            e.className.replace(/\bplaceholder-shown\b/g, "").trim() +
            " placeholder-shown"
          ).trim())
        : (e.className = e.className
            .replace(/\bplaceholder-shown\b/g, "")
            .trim()));
  }
  function p() {
    var e = {
        name: i.name.value.trim(),
        email: i.email.value.trim(),
        type: i.enquiryType.value,
        country: i.countryType.value,
        msg: i.enquiryMessage.value.trim(),
        order: i.orderNumber.value.trim(),
        token: a.token,
      },
      t = {
        name: !e.name,
        email: !e.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.email),
        enquiryType: !e.type,
        countryType: !e.country,
        enquiryMessage: !e.msg,
        orderNumber: "" !== e.order && !d(e.order),
        recaptcha: !e.token,
      };
    (u("name", t.name),
      u("email", t.email),
      u("enquiryType", t.enquiryType),
      u("countryType", t.countryType),
      u("enquiryMessage", t.enquiryMessage),
      u("orderNumber", t.orderNumber),
      u("recaptcha", t.recaptcha));
    var n = g(!1);
    u("attachment", n);
    var r = !1;
    for (var o in t)
      if (t[o]) {
        r = !0;
        break;
      }
    return (
      (r = r || n),
      (i.btn.disabled = r || a.submitting),
      i.btn.setAttribute("aria-disabled", String(r || a.submitting)),
      !r
    );
  }
  function g(e) {
    var t = a.selectedFiles;
    if (!t || 0 === t.length) return !1;
    if (t.length > r.maxFiles)
      return (e && S("Maximum " + r.maxFiles + " files allowed.", "error"), !0);
    for (var n = 0, i = 0; i < t.length; i++) {
      var o = t[i];
      if (((n += o.size), o.size > r.maxSingleSize))
        return (
          e && S('"' + o.name + '" exceeds the 10 MB per-file limit.', "error"),
          !0
        );
      if (o.type && -1 === r.allowedTypes.indexOf(o.type))
        return (
          e &&
            S(
              '"' +
                o.name +
                '" is not an accepted file type. Please upload images or PDFs.',
              "error",
            ),
          !0
        );
    }
    return (
      n > r.maxTotalSize &&
      (e &&
        S(
          "Total attachment size (" + c(n) + ") exceeds the 20 MB limit.",
          "error",
        ),
      !0)
    );
  }
  function v() {
    if ("undefined" != typeof DataTransfer) {
      for (var e = new DataTransfer(), t = 0; t < a.selectedFiles.length; t++)
        e.items.add(a.selectedFiles[t]);
      i.attachment.files = e.files;
    }
  }
  function h(e) {
    return e.type && 0 === e.type.indexOf("image")
      ? "image"
      : "application/pdf" === e.type
        ? "pdf"
        : "other";
  }
  function b(e) {
    var t = e.split(".");
    return t.length < 2 ? "FILE" : t[t.length - 1].toUpperCase();
  }
  function E() {
    if (i.fileList) {
      i.fileList.innerHTML = "";
      var e = a.selectedFiles;
      if (e && 0 !== e.length)
        for (var t = 0; t < e.length; t++) {
          var n = document.createElement("li"),
            r = document.createElement("span"),
            o = h(e[t]);
          ((r.className = "file-type-icon type-" + o),
            (r.textContent = b(e[t].name)),
            n.appendChild(r));
          var l = document.createElement("span");
          l.className = "file-info";
          var s = document.createElement("span");
          ((s.className = "file-name"), (s.textContent = e[t].name));
          var u = document.createElement("span");
          ((u.className = "file-size"),
            (u.textContent = c(e[t].size)),
            l.appendChild(s),
            l.appendChild(u),
            n.appendChild(l));
          var d = document.createElement("button");
          ((d.type = "button"),
            (d.className = "file-remove"),
            d.setAttribute("aria-label", "Remove " + e[t].name),
            (d.innerHTML =
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'),
            (function (e) {
              d.addEventListener("click", function () {
                var t;
                ((t = e), a.selectedFiles.splice(t, 1), v(), E(), T(), p());
              });
            })(t),
            n.appendChild(d),
            i.fileList.appendChild(n));
        }
    }
  }
  function T() {
    if (i.fileSummary) {
      var e = a.selectedFiles;
      if (e && 0 !== e.length) {
        for (var t = 0, n = 0; n < e.length; n++) t += e[n].size;
        i.fileSummary.textContent =
          e.length +
          " file" +
          (1 !== e.length ? "s" : "") +
          " • " +
          c(t) +
          " of 20 MB used";
      } else i.fileSummary.textContent = "";
    }
  }
  function w() {
    if (i.charCount) {
      var e = i.enquiryMessage.value.length,
        t = 2e3,
        n = e.toLocaleString ? e.toLocaleString() : e,
        r = t.toLocaleString ? t.toLocaleString() : t;
      ((i.charCount.textContent = n + " / " + r),
        (i.charCount.style.color = e > 1800 ? "#d32f2f" : ""));
    }
  }
  function k(e) {
    var t = e.target;
    ((a.formDirty = !0),
      "blur" === e.type || "focusout" === e.type
        ? (t.setAttribute("data-touched", "true"), p())
        : l(),
      t === i.enquiryMessage && w(),
      t.id && y(t.id),
      "SELECT" === t.tagName && f(t),
      (function () {
        try {
          var e = {
            name: i.name.value,
            email: i.email.value,
            orderNumber: i.orderNumber.value,
            enquiryType: i.enquiryType.value,
            countryType: i.countryType.value,
            enquiryMessage: i.enquiryMessage.value,
          };
          sessionStorage.setItem(s, JSON.stringify(e));
        } catch (e) {}
      })());
  }
  function x(e) {
    var t = e.target;
    if ((t.setAttribute("data-touched", "true"), t.files && t.files.length > 0))
      for (var n = 0; n < t.files.length; n++) a.selectedFiles.push(t.files[n]);
    (a.selectedFiles.length > r.maxFiles &&
      (a.selectedFiles = a.selectedFiles.slice(0, r.maxFiles)),
      v(),
      g(!0) && ((a.selectedFiles = []), v()),
      E(),
      T(),
      p());
  }
  function I(t) {
    if ((t.preventDefault(), !a.submitting)) {
      if (i.honeypot && i.honeypot.value)
        return (
          S(
            "Message sent successfully! We will get back to you soon.",
            "success",
          ),
          void L()
        );
      for (
        var n = e.querySelectorAll("input, select, textarea"), o = 0;
        o < n.length;
        o++
      )
        n[o].setAttribute("data-touched", "true");
      if ((i.tokenInput.setAttribute("data-touched", "true"), p()))
        if (
          "undefined" == typeof navigator ||
          !("onLine" in navigator) ||
          navigator.onLine
        ) {
          ((a.submitting = !0),
            (i.btn.disabled = !0),
            i.btn.setAttribute("aria-busy", "true"),
            (i.btn.innerHTML =
              '<span class="spinner" aria-hidden="true"></span> Sending…'));
          var l = new FormData(e),
            s =
              "undefined" != typeof AbortController
                ? new AbortController()
                : null,
            u = null;
          s &&
            (u = setTimeout(function () {
              s.abort();
            }, r.fetchTimeout));
          var d = { method: "POST", body: l };
          (s && (d.signal = s.signal),
            fetch(r.workerUrl, d)
              .then(function (e) {
                return (
                  u && clearTimeout(u),
                  e.text().then(function (t) {
                    return { ok: e.ok, status: e.status, body: t };
                  })
                );
              })
              .then(function (e) {
                e.ok && "ok" === e.body.trim()
                  ? (S(
                      "Message sent successfully! We will get back to you soon.",
                      "success",
                    ),
                    L())
                  : 429 === e.status
                    ? S(
                        "Too many requests. Please wait a moment and try again.",
                        "error",
                      )
                    : (console.error(
                        "Server Error (" + e.status + "):",
                        e.body,
                      ),
                      S(
                        "Something went wrong on our end. Please try again later.",
                        "error",
                      ));
              })
              .catch(function (e) {
                (u && clearTimeout(u),
                  e && "AbortError" === e.name
                    ? S(
                        "The request timed out. Please check your connection and try again.",
                        "error",
                      )
                    : "undefined" != typeof navigator &&
                        "onLine" in navigator &&
                        !navigator.onLine
                      ? S(
                          "You appear to be offline. Please check your internet connection.",
                          "error",
                        )
                      : (console.error("Network Error:", e),
                        S(
                          "A network error occurred. Please try again.",
                          "error",
                        )));
              })
              .then(function () {
                ((a.submitting = !1),
                  (i.btn.disabled = !1),
                  i.btn.removeAttribute("aria-busy"),
                  (i.btn.textContent = "Send Message"),
                  p());
              }));
        } else
          S(
            "You appear to be offline. Please check your internet connection and try again.",
            "error",
          );
      else {
        var c = e.querySelector('.field-tooltip[style*="block"]');
        c && c.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }
  function L() {
    e.reset();
    for (
      var t = document.querySelectorAll("[data-touched]"), n = 0;
      n < t.length;
      n++
    )
      t[n].setAttribute("data-touched", "false");
    for (var r = e.querySelectorAll(".field-tooltip"), o = 0; o < r.length; o++)
      r[o].style.display = "none";
    ((a.token = ""),
      (a.selectedFiles = []),
      (a.formDirty = !1),
      (i.tokenInput.value = ""),
      i.fileList && (i.fileList.innerHTML = ""),
      i.fileSummary && (i.fileSummary.textContent = ""),
      w(),
      f(i.enquiryType),
      f(i.countryType));
    for (var l = e.querySelectorAll(".field-hint"), u = 0; u < l.length; u++)
      l[u].className = "field-hint";
    if (
      ((function () {
        try {
          sessionStorage.removeItem(s);
        } catch (e) {}
      })(),
      window.turnstile && null !== a.widgetId)
    )
      try {
        turnstile.reset(a.widgetId);
      } catch (e) {}
  }
  function S(e, t) {
    ((i.popupMsg.textContent = e),
      (i.popup.className = t),
      i.iconSuccess &&
        (i.iconSuccess.style.display = "success" === t ? "block" : "none"),
      i.iconError &&
        (i.iconError.style.display = "error" === t ? "block" : "none"),
      (i.overlay.style.display = "flex"),
      i.closePopup.focus());
  }
  function q() {
    ((i.overlay.style.display = "none"), i.btn.focus());
  }
  function N(e) {
    if (
      "flex" === i.overlay.style.display &&
      ("Tab" === e.key || 9 === e.keyCode)
    ) {
      var t = i.popup.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      );
      if (t.length) {
        var n = t[0],
          r = t[t.length - 1];
        e.shiftKey
          ? document.activeElement === n && (e.preventDefault(), r.focus())
          : document.activeElement === r && (e.preventDefault(), n.focus());
      }
    }
  }
  function B(e) {
    ("Escape" !== e.key && 27 !== e.keyCode) ||
      "flex" !== i.overlay.style.display ||
      q();
  }
  function F(e) {
    e.target === i.overlay && q();
  }
  function M(e) {
    a.formDirty && !a.submitting && (e.preventDefault(), (e.returnValue = ""));
  }
  function A() {
    if (
      ((i.startTime.value = Date.now()),
      e.addEventListener("input", k),
      e.addEventListener("focusout", k),
      i.attachment.addEventListener("change", x),
      i.closePopup.addEventListener("click", q),
      i.overlay.addEventListener("click", F),
      document.addEventListener("keydown", B),
      document.addEventListener("keydown", N),
      e.addEventListener("submit", I),
      window.addEventListener("beforeunload", M),
      e.addEventListener("focusin", function (e) {
        e.target.id && y(e.target.id);
      }),
      f(i.enquiryType),
      f(i.countryType),
      i.dropZone)
    ) {
      var t = function (e) {
          (e.preventDefault(), e.stopPropagation());
        },
        n = function () {
          i.dropZone.className = "file-drop-zone";
        };
      (i.dropZone.addEventListener("dragenter", t),
        i.dropZone.addEventListener("dragover", function (e) {
          (t(e), (i.dropZone.className = "file-drop-zone dragover"));
        }),
        i.dropZone.addEventListener("dragleave", function (e) {
          (t(e), n());
        }),
        i.dropZone.addEventListener("drop", function (e) {
          if (
            (t(e),
            n(),
            e.dataTransfer &&
              e.dataTransfer.files &&
              e.dataTransfer.files.length)
          ) {
            i.attachment.setAttribute("data-touched", "true");
            for (var o = 0; o < e.dataTransfer.files.length; o++)
              a.selectedFiles.push(e.dataTransfer.files[o]);
            (a.selectedFiles.length > r.maxFiles &&
              (a.selectedFiles = a.selectedFiles.slice(0, r.maxFiles)),
              v(),
              g(!0) && ((a.selectedFiles = []), v()),
              E(),
              T(),
              p());
          }
        }));
    }
    (w(),
      (function () {
        try {
          var e = sessionStorage.getItem(s);
          if (!e) return;
          var t = JSON.parse(e);
          (t.name && (i.name.value = t.name),
            t.email && (i.email.value = t.email),
            t.orderNumber && (i.orderNumber.value = t.orderNumber),
            t.enquiryType &&
              ((i.enquiryType.value = t.enquiryType), f(i.enquiryType)),
            t.countryType &&
              ((i.countryType.value = t.countryType), f(i.countryType)),
            t.enquiryMessage && (i.enquiryMessage.value = t.enquiryMessage),
            w(),
            (t.name || t.email || t.enquiryMessage) && (a.formDirty = !0));
        } catch (e) {}
      })(),
      window.addEventListener("online", function () {
        p();
      }),
      window.addEventListener("offline", function () {
        ((i.btn.disabled = !0), i.btn.setAttribute("aria-disabled", "true"));
      }),
      window.turnstile && null === a.widgetId && window.onTurnstileLoaded());
  }
})();
